import { render, staticRenderFns } from "./focusenterprises.vue?vue&type=template&id=38dd92b8&"
import script from "./focusenterprises.vue?vue&type=script&lang=js&"
export * from "./focusenterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports